<template>
    <div class="photo-lower-bar-button-group">
        <div class="photo-lower-bar-button" v-on:click="deleteSelectedPlane()">
            <SVGPhotoDelete class="lb-svg"/>
            <span class="photo-lower-bar-button-text extra-left-padding">Удалить</span>
        </div>
        <div class="photo-lower-bar-button" v-on:click="editSelectedPlane()" v-show="routeName === 'planeCategoriesActiveSelection'">
            <SVGAdminEditRow class="lb-svg"/>
            <span class="photo-lower-bar-button-text extra-left-padding">Редактировать плоскость</span>
        </div>
        <div class="photo-lower-bar-button" v-show="!cutoutPlanes">
            <div class="pretty p-default lb-checkbox">
                <input type="checkbox" v-model="useInCalculations"/>
                <div class="state p-danger">
                    <label></label>
                </div>
            </div>
            <span class="photo-lower-bar-button-text extra-left-padding">Учитывать при расчётах</span>
        </div>
    </div>
</template>

<script>
    import SVGPhotoDelete from "../../SVG/SVGPhotoDelete";
    import {bus} from "../../../vue_bus";
    import SVGAdminEditRow from "../../SVG/SVGAdminEditRow";

    export default {
        name: "LeftLowerBarDeletePlane",
        components: {
            SVGAdminEditRow,
            SVGPhotoDelete
        },
        computed: {
            routeName() {
                return this.$store.state.route.name;
            },
            useInCalculations: {
                get: function () {
                    return this.$store.getters['active/TAKE_INTO_CALCULATIONS'];
                },
                set: function (newValue) {
                    this.$store.dispatch('active/TAKE_INTO_CALCULATIONS', newValue);
                }
            },
            cutoutPlanes() {
                return(["door", "window", "cutout"].includes(this.$store.getters["active/ACTIVE_PLANE"].type))
            }
        },
        methods: {
            deleteSelectedPlane() {
                this.$store.dispatch('active/DELETE_PLANE');
                bus.$emit('refreshFabric');
                this.$router.replace({
                    name: "planeCategories",
                    query: this.$route.query
                }).catch(() => {});
            },
            editSelectedPlane() {
                const plane = this.$store.getters["active/ACTIVE_PLANE"];
                let routeName
                if (plane.type === 'additional') {
                    routeName = 'additionalManual'
                } else {
                    routeName = plane.type
                }
                if(plane){
                    this.$router.push({
                        name: routeName,
                        query: this.$route.query
                    }).catch(() => {});
                }
            }
        }
    }
</script>

<style scoped>
    .sidebar-checkbox {
        line-height: unset;
        margin: auto;
    }
</style>
